{
  "common": {
    "pcs": "pcs"
  },
  "status": {
    "normal": "Normal",
    "warning": "Warning",
    "danger": "Danger",
    "offline": "No data",
    "unknown": "Unknown"
  },
  "live": {
    "lastUpdate": "Last update: {{time}}",
    "reconnecting": "Connection lost — reconnecting…"
  },
  "elements": {
    "titlePlaceholder": "Enter a title",
    "subtitlePlaceholder": "Enter the site name",
    "imagePlaceholder": "Upload an image",
    "gifPlaceholder": "Upload a GIF",
    "videoPlaceholder": "Upload a video",
    "sectionsPlaceholder": "Sections appear here",
    "play": "Play"
  },
  "languages": {
    "uz-Latn": "O’zb",
    "ru": "Рус",
    "en": "Eng"
  },
  "languageNames": {
    "uz-Latn": "O'zbekcha",
    "ru": "Русский",
    "en": "English"
  },
  "topbar": {
    "language": "Interface language",
    "notifications": "Notifications",
    "noNotifications": "No new notifications.",
    "themeToLight": "Switch to light theme",
    "themeToDark": "Switch to dark theme",
    "userMenu": "User menu",
    "online": "Online",
    "edit": "Edit",
    "editDashboard": "Edit the dashboard",
    "logout": "Sign out"
  },
  "viewer": {
    "loading": "Loading…",
    "loadError": "Could not load the data",
    "retry": "Try again",
    "emptyDashboard": "The dashboard is not set up yet",
    "emptyDashboardHint": "Once an administrator adds a background, widgets and sections, they will appear here.",
    "dashboard": "Dashboard",
    "backToDashboard": "Back to the dashboard",
    "sectionsNav": "Sections",
    "collapseMenu": "Collapse menu",
    "expandMenu": "Expand menu",
    "folders": "Folders",
    "statusLegend": "Device status",
    "fullscreen": "Full screen",
    "exitFullscreen": "Exit full screen",
    "deviceInfo": "Device information",
    "edit": "Edit",
    "sectionNotFound": "Section not found",
    "emptySection": "This section has no content yet",
    "emptySectionHint": "Drawings, tables and charts appear here once they are added."
  },
  "panels": {
    "drawing": "Devices on the drawing",
    "table": "Table",
    "chart": "Device chart"
  },
  "table": {
    "index": "No.",
    "device": "Device",
    "measuredAt": "Measured at",
    "value": "Value",
    "status": "Status",
    "empty": "No devices to show",
    "formulaError": "Error"
  },
  "chart": {
    "noSeries": "No devices selected for the chart",
    "waiting": "Waiting for data…",
    "time": "Time"
  },
  "deviceInfo": {
    "title": "Device information",
    "subtitle": "Device information · {{tenant}}",
    "readings": "Readings",
    "noReadings": "No readings are bound to this device",
    "media": "Photos and videos",
    "mediaCount": "{{count}}",
    "description": "Description",
    "empty": "No additional information about this device yet.",
    "close": "Close",
    "pdf": "Download PDF",
    "previous": "Previous",
    "next": "Next"
  }
}
